import { useMediaQuery } from "@mui/material";

const useIsDesktop = () => {
  const IsDesktopMedia = useMediaQuery("(max-width:1920px)");
  return IsDesktopMedia;
};

export default useIsDesktop;
